// removed by extract-text-webpack-plugin
module.exports = {"searchInput":"TMGNSEsiL-6eFP9XK0CQU","searchHint":"kVRM61Nsk5Ky-rINcIpTE","list":"QIFIz5-Wp2HkHZjxugdUS"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/StatisticsRecipients/StatisticsRecipients.scss
// module id = 1386
// module chunks = 1